function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { generateCloudinaryImageUrl } from "services/community/cloudinary-service";
import { getDynamicAssetConfigForPath } from "/client/services/cluster-config-service/cluster-config-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withRouter } from "next/router";
import classnames from "classnames";
import DefaultProps from "./default-props";
import { StyledFullBackgroundTextAndAsset } from "./full-background-text-and-asset.scss";
class FullBackgroundTextAndAsset extends PureComponent {
    render() {
        const { fullParagraph, titleSize, textSize, withDynamicParagraphTitle, withDynamicParagraphSubtitle, spaceFromParagraph, topicBottomMargin, buttonTopMargin, paragraphVerticalAlignment } = this.props;
        const imageAccessibilityProps = this.getImageAccessibilityProps();
        return /*#__PURE__*/ _jsx(StyledFullBackgroundTextAndAsset, _object_spread_props(_object_spread({
            className: "full-background-text-and-asset",
            style: {
                backgroundImage: `url(${this.getImageSrc()})`
            }
        }, imageAccessibilityProps), {
            children: /*#__PURE__*/ _jsx("div", {
                className: classnames("full-background-text-and-asset-content", paragraphVerticalAlignment),
                children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({
                    titleSize: titleSize,
                    textSize: textSize,
                    withDynamicParagraphTitle: withDynamicParagraphTitle,
                    withDynamicParagraphSubtitle: withDynamicParagraphSubtitle,
                    spaceFromParagraph: spaceFromParagraph,
                    topicBottomMargin: topicBottomMargin,
                    buttonTopMargin: buttonTopMargin
                }, fullParagraph))
            })
        }));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getImageSrc", ()=>{
            const { backgroundImage, assetQuality, useDynamicAsset, clusterConfig, activePagePath } = this.props;
            const { src } = backgroundImage;
            const dynamicAssetConfig = useDynamicAsset && getDynamicAssetConfigForPath(clusterConfig, activePagePath);
            const url = (dynamicAssetConfig === null || dynamicAssetConfig === void 0 ? void 0 : dynamicAssetConfig.src) || generateCloudinaryImageUrl(src, null, {
                assetQuality
            });
            return `'${url}'`;
        });
        _define_property(this, "getImageAccessibilityProps", ()=>{
            const { backgroundImage } = this.props;
            if (!(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.alt)) return {};
            return {
                "aria-label": backgroundImage.alt,
                role: "img"
            };
        });
    }
}
FullBackgroundTextAndAsset.defaultProps = DefaultProps;
export default withGenericConfig(withRouter(FullBackgroundTextAndAsset));
